(() => {
  const STORAGE_KEY = 'pecoliWishlist';

  function getWishlist() {
    try {
      const savedWishlist = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(savedWishlist) ? savedWishlist : [];
    } catch (error) {
      console.warn('Não foi possível ler os favoritos.', error);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

      document.dispatchEvent(
        new CustomEvent('pecoli:wishlist-updated', {
          detail: { items }
        })
      );
    } catch (error) {
      console.warn('Não foi possível guardar os favoritos.', error);
    }
  }

  function getProductFromButton(button) {
    return {
      id: String(button.dataset.productId || ''),
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || ''
    };
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    const productTitle =
      button.dataset.productTitle || 'este produto';

    button.setAttribute(
      'aria-label',
      active
        ? `Remover ${productTitle} dos favoritos`
        : `Adicionar ${productTitle} aos favoritos`
    );
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    const savedProductIds = new Set(
      wishlist.map((item) => String(item.id))
    );

    document
      .querySelectorAll('[data-wishlist-button]')
      .forEach((button) => {
        const productId = String(button.dataset.productId || '');

        setButtonState(
          button,
          savedProductIds.has(productId)
        );
      });
  }

  function updateWishlistCounters() {
    const wishlist = getWishlist();
    const count = wishlist.length;

    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach((counter) => {
        counter.textContent = String(count);
        counter.hidden = count === 0;

        counter.setAttribute(
          'aria-label',
          count === 1
            ? '1 produto nos favoritos'
            : `${count} produtos nos favoritos`
        );
      });
  }

  function toggleWishlist(button) {
    const product = getProductFromButton(button);

    if (!product.id) {
      return;
    }

    const wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(
      (item) => String(item.id) === product.id
    );

    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.push(product);
    }

    saveWishlist(wishlist);
  }

  function removeWishlistItem(productId) {
    const wishlist = getWishlist().filter(
      (item) => String(item.id) !== String(productId)
    );

    saveWishlist(wishlist);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'pt-PT',
        {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR'
        }
      ).format(amount);
    } catch (error) {
      return `${amount.toFixed(2).replace('.', ',')} €`;
    }
  }

  async function getProductDetails(item) {
    if (!item.handle) {
      return null;
    }

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}products/${item.handle}.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      console.warn(
        `Não foi possível carregar o produto ${item.handle}.`,
        error
      );

      return null;
    }
  }

  function createWishlistCard(item, product) {
    const article = document.createElement('article');
    article.className = 'pecoli-wishlist-card';

    const productUrl =
      product?.url ||
      item.url ||
      (item.handle ? `/products/${item.handle}` : '#');

    const imageUrl =
      product?.featured_image ||
      product?.images?.[0] ||
      item.image ||
      '';

    const productTitle =
      product?.title ||
      item.title ||
      'Produto';

    const price =
      typeof product?.price === 'number'
        ? formatMoney(product.price)
        : '';

    const available =
      typeof product?.available === 'boolean'
        ? product.available
        : null;

    article.innerHTML = `
      <a
        class="pecoli-wishlist-card__image-wrapper"
        href="${productUrl}"
        aria-label="${escapeHtml(productTitle)}"
      >
        ${
          imageUrl
            ? `
              <img
                class="pecoli-wishlist-card__image"
                src="${imageUrl}"
                alt="${escapeHtml(productTitle)}"
                loading="lazy"
                width="600"
                height="600"
              >
            `
            : ''
        }
      </a>

      <button
        type="button"
        class="pecoli-wishlist-card__remove"
        aria-label="Remover ${escapeHtml(productTitle)} dos favoritos"
        data-wishlist-remove
        data-product-id="${escapeHtml(String(item.id || ''))}"
      >
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M12 21s-7.2-4.6-9.5-9C.4 8 .9 3.5 4.5 2.1 7 1.1 9.8 2.1 12 4.6c2.2-2.5 5-3.5 7.5-2.5C23.1 3.5 23.6 8 21.5 12 19.2 16.4 12 21 12 21Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <div class="pecoli-wishlist-card__information">
        <h2 class="pecoli-wishlist-card__title">
          <a href="${productUrl}">
            ${escapeHtml(productTitle)}
          </a>
        </h2>

        ${
          price
            ? `<p class="pecoli-wishlist-card__price">${price}</p>`
            : ''
        }

        ${
          available === false
            ? `<p class="pecoli-wishlist-card__status">Esgotado</p>`
            : ''
        }
      </div>
    `;

    return article;
  }

  async function renderWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');

    if (!grid) {
      return;
    }

    const emptyState = document.querySelector(
      '[data-wishlist-empty]'
    );

    const countElement = document.querySelector(
      '[data-wishlist-page-count]'
    );

    const wishlist = getWishlist();

    if (countElement) {
      countElement.textContent =
        wishlist.length === 1
          ? '1 produto'
          : `${wishlist.length} produtos`;
    }

    if (wishlist.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;

      if (emptyState) {
        emptyState.hidden = false;
      }

      return;
    }

    grid.hidden = false;

    if (emptyState) {
      emptyState.hidden = true;
    }

    grid.innerHTML = '';

    const results = await Promise.all(
      wishlist.map(async (item) => ({
        item,
        product: await getProductDetails(item)
      }))
    );

    results.forEach(({ item, product }) => {
      grid.appendChild(
        createWishlistCard(item, product)
      );
    });
  }

  function initialiseWishlist() {
    updateWishlistButtons();
    updateWishlistCounters();
    renderWishlistPage();
  }

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest(
      '[data-wishlist-button]'
    );

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();

      toggleWishlist(wishlistButton);
      return;
    }

    const removeButton = event.target.closest(
      '[data-wishlist-remove]'
    );

    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();

      removeWishlistItem(
        removeButton.dataset.productId
      );
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    initialiseWishlist
  );

  document.addEventListener(
    'shopify:section:load',
    initialiseWishlist
  );

  document.addEventListener(
    'pecoli:wishlist-updated',
    initialiseWishlist
  );

  if (document.readyState !== 'loading') {
    initialiseWishlist();
  }
})();